import * as Hooks from "./hooks";
import * as Components from "./OmniFilterPanel";

export const useOmniFilter = Hooks.useOmniFilter;
export const OmniFilterPanel = Components.OmniFilterPanel;
